import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {of} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Sort, MatSort} from '@angular/material/sort';
import {TableDataSource} from 'src/app/shared/components/table/table-data-source';
import {Delegation} from 'src/app/shared/models/delegation.model';
import {DelegationService} from 'src/app/shared/services/delegation.service';
import {map, tap} from 'rxjs/operators';
import {Cost, CostStatuses} from 'src/app/shared/models/cost.model';
import {tableSortFn} from 'src/app/shared/utils/sort.util';
import {del} from 'selenium-webdriver/http';
import {ToastrService} from 'ngx-toastr';
import {CostService} from '../../shared/services/cost.service';
import {ConfirmService} from '../../shared/services/confirm.service';
import {Redirect} from '../../shared/utils/redirect.util';


@Component({
  selector: 'app-delegations',
  templateUrl: './delegations.component.html'
})
export class DelegationsComponent implements OnInit {
  readonly delegationStatuses = CostStatuses;
  delegations$;
  dataSource = new TableDataSource<Delegation>();
  displayColumns: string[] = ['delegationNumber', 'status.name', 'advance.name', 'createdAt', 'grossValue', 'forwardedToPaymentAt', 'returnedAt', 'action'];


  // Sorting doesn't work with *ngIf in some element above a table,
  // some elements, especially directives, sometime are not initialized on ngOnInit hook when created after *ngIf
  // One of the solutions is to initialize it in ngAfterViewInit hook or the second is to use 'set'
  @ViewChild(MatSort, {static: false}) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private serviceDelegation: DelegationService,
    private toastrService: ToastrService,
    private costService: CostService,
    private confirmService: ConfirmService,
    private redirect: Redirect,
  ) {

  }

  ngOnInit() {

    this.delegations$ = this.serviceDelegation.fetchCurrentUserDelegations()
      .pipe(
        map((delegations: Delegation[]) => {
          this.dataSource.data = delegations;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return delegations;
        })
      );
  }

  removeDelegation(cost: any) {
    if (cost.canRemove) {
      this.confirmService.openConfirmDialog('Czy na pewno chcesz usunąć delegację? Zmiana będzie nieodwracalna.')
        .afterClosed().subscribe(confirm => {
        if (confirm) {
          this.costService.removeCost(cost.id).subscribe(res => {
            this.toastrService.success('Delegacja została usunięta.');
            this.redirect.to();
          }, _ => this.toastrService.error('Delegacja nie może zostać usunięta.'));
        }
      });
    }
  }
}
